export const STRATEGY = {
  POLLING: "ping",
  EVENT: "event"
};

export const STATUS = {
  CONNECTED: "connected",
  DISCONNECTED: "disconnected"
};
